import { HTMLAttributes, useMemo } from "react";
import defaultUserImage from "../../../../assets/op_o.png";
import type { UserProfile } from "../../../../client";
import { Image } from "../../../../components";
import { getImageUrl } from "../../../../utils/image";
import { cn } from "../../../../components/utils/cn";
import { AnimatedPanel } from "../../home/components/panel";
import { MagicLoadingCard } from "../../member/components/MagicLoadingCard";
import TooltipContainer from "../../home/components/TooltipContainer";

interface Props extends UserProfile {
  onClick?: () => void;
  isImporting: boolean;
}

export const CompactMemberCard = ({
  profileData,
  profilePhotoId,
  onClick,
  isImporting = false,
}: Props) => {
  const profileName = useMemo(() => {
    if (typeof profileData.name === "string") {
      return profileData.name !== "" ? profileData.name : "New profile";
    }
    return "Unknown";
  }, [profileData.name]);

  if (isImporting === true) {
    return (
      <div className="rounded-3xl min-w-48 max-w-48 h-48 border border-gray-1 bg-white overflow-hidden group hover:cursor-pointer">
        <MagicLoadingCard>
          <h2 className="font-extrabold text-gray-5">
            Creating master profile
            <br />
            This might take a few minutes
          </h2>
        </MagicLoadingCard>
      </div>
    );
  }

  return (
    <TooltipContainer
      tooltipText={
        typeof profileData.name === "string" && profileData.name !== ""
          ? profileData.name
          : "Empty profile"
      }
      side="bottom"
      sideOffset={-60}
    >
      <div
        className="rounded-3xl min-w-48 max-w-48 border border-gray-1 bg-white overflow-hidden group hover:cursor-pointer"
        onClick={onClick}
      >
        <div className="aspect-square overflow-hidden">
          <Image
            alt={
              typeof profileData.name === "string"
                ? profileData.name
                : "Profile"
            }
            src={
              profilePhotoId ? getImageUrl(profilePhotoId) : defaultUserImage
            }
            className="w-full h-full object-cover group-hover:scale-110 group-[[data-state=delayed-open]]:scale-110 group-[[data-state=instant-open]]:scale-110 group-active:scale-105 transition-transform"
          />
        </div>
      </div>
    </TooltipContainer>
  );
};

CompactMemberCard.displayName = "CompactMemberCard";
